{
  "actions": "פעולות"
}
